<template>
    <section>
        <div class="event-box">
            <div v-if="edit">
                <div class="data">
                    <select v-model="event.comparision" class="control-inline form-control">
                        <option v-for="option in compareOptions" :key="option.value" v-bind:value="option.value">
                            {{ $t(option.text) }}
                        </option>
                    </select>
                    <input v-model="event.liters" type="text" class="control-inline form-control"> {{$t(unit === 'liters' ? 'message.liters' : 'message.watts')}}
                    {{$t('message.between')}}
                    <select v-model="event.start" class="control-inline form-control">
                        <option v-for="option in hourOptions" :key="option.value" v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    {{$t('message.and')}}
                    <select v-model="event.end" class="control-inline form-control">
                        <option v-for="option in hourOptions" :key="option.value" v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                    <div class="source">
                        {{$t('message.alarm_data_source')}}
                        <select v-model="event.source" class="form-control">
                            <option v-for="option in sourceOptions" :key="option.value" :value="option.value">
                                {{ $t(option.text) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="actions">
                    <b-btn @click="save" type="success">{{$t('message.save')}}</b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
            <div v-else>
                <div class="data">
                    {{$t(translate[event.comparision])}} {{event.liters}} {{$t(unit === 'liters' ? 'message.liters' : 'message.watts')}}
                    {{$t('message.between')}} {{event.start}} a {{event.end}}
                    <div class="source-label">
                        {{$t('message.alarm_data_source')}}: {{ sourceLabel(event.source) }}
                    </div>
                </div>
                <div class="actions">
                    <b-btn @click="edit=true"><i class="fa fa-pencil"></i></b-btn>
                    <b-btn @click="remove"><i class="fa fa-trash"></i></b-btn>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Base from './Base'

    export default {
        name: 'Sum',
        extends: Base,
        data () {
            return {
                sourceOptions: [
                    {value: 'auto', text: 'message.alarm_source_auto'},
                    {value: 'control', text: 'message.alarm_source_control'},
                    {value: 'structure', text: 'message.alarm_source_structure'}
                ]
            }
        },
        methods: {
            sourceLabel (source) {
                const option = this.sourceOptions.find(item => item.value === source) || this.sourceOptions[0]
                return this.$t(option.text)
            }
        },
        created () {
            if (!this.sourceOptions.some(item => item.value === this.event.source)) {
                this.event.source = 'auto'
            }
        }
    }
</script>

<style scoped>
    @import 'base.css';

    .data {
        flex-wrap: wrap;
    }

    .source {
        display: flex;
        flex: 0 0 100%;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        margin-top: 10px;
        width: 100%;
    }

    .source .form-control {
        width: auto;
        min-width: 280px;
        max-width: 100%;
    }

    .source-label {
        margin-top: 6px;
        color: #777;
        font-size: 13px;
    }
</style>
